import './AdultPaywall.sass';

import React, { FC, useCallback, useEffect, useMemo, useState } from 'react';

import { Button, Header, ScrollView } from '$uikit';
import { PROFILE } from '$shared/constants/pages';
import { AdultPaywallProps } from '$core/Subscription/AdultPaywall/AdultPaywall.interface';
import { useCurrentLang, useDesktop, useTranslator } from '$hooks';
import { Loader, Slider, Viewer } from '$shared/components';
import { formatBigNumber, formatCurrency, statReachGoal, isBlackFriday } from '$utils';
import { useDispatch, useSelector } from 'react-redux';
import { setSubscriptionContentPriority } from '$utils/subscriptionAuthor';
import { ContentPriorityType } from '$store/main/interface';
import { IcCheck28, IcHot28, IcMessage28, IcPhone28, IcPlay28 } from '$assets';
import { profileActions } from '$store/profile';
import { authSelector } from '$store/auth';
import { AuthPopoverState, CurrencyEnum } from '$store/models';
import { AuthPopoverSimple } from '$core';
import { ViewerItem } from '$shared/components/Viewer/VieverItem/ViewerItem.interface';
import router from '$navigation/router';
import { mainSelector } from '$store/main';

interface PaywallModel {
  id: number;
  name: string;
  photo: {
    default: string;
  };
  inst?: {
    subs: number;
    link: string;
  };
  welcomeVideo?: {
    lang: string;
    videoId?: number;
    photoMedium?: string;
    photoLarge?: string;
    source: string;
    thumbnail?: string;
    width: number;
    height: number;
    encrypted?: boolean;
    duration?: number;
  };
}

export const AdultPaywallNew: FC<AdultPaywallProps> = (props) => {
  const { subscriptionPrice, handleSubscription, subscriptionRubPrice } = props;

  const t = useTranslator();
  const [currentViewerItem, setCurrentViewerItem] = useState<number | null>(null);
  const isDesktop = useDesktop();
  const { isLogged } = useSelector(authSelector);
  const dispatch = useDispatch();
  const currentLang = useCurrentLang();

  const models = useMemo(() => {
    return [
      {
        id: 166941,
        name: 'Diana Melison',
        photo: require('./assets/Diana_Melison.png'),
        inst: {
          subs: 2000000,
          link: 'https://www.instagram.com/di_melison',
        },
        welcomeVideo: {
          lang: currentLang.key === 'ru' ? 'ru' : 'en',
          source:
            currentLang.key === 'ru'
              ? '[{"resolution":720,"path":"https://tonplace.ams3.cdn.digitaloceanspaces.com/test/IMG_1261.mp4"}]'
              : '[{"resolution":720,"path":"https://tonplace.ams3.cdn.digitaloceanspaces.com/test/IMG_1258.MP4"}]',
          width: 720,
          height: 1280,
        },
      },
      {
        id: 280063,
        name: 'Lilyermak Ermak',
        photo: require('./assets/Lilyermak_Ermak.png'),
        inst: {
          subs: 1700000,
          link: 'https://instagram.com/lilyermak?igshid=YmMyMTA2M2Y=',
        },
        welcomeVideo: {
          lang: 'ru',
          source:
            '[{"resolution":720,"path":"https://tonplace.ams3.cdn.digitaloceanspaces.com/test/IMG_1266.mp4"}]',
          width: 720,
          height: 1280,
        },
      },
      {
        id: 283937,
        name: 'Adelalinka Twins',
        photo: require('./assets/Adelalinka_Twins.png'),
        inst: {
          subs: 253000,
          link: 'https://instagram.com/adelalinka_life?igshid=YmMyMTA2M2Y=',
        },
        welcomeVideo: {
          lang: 'ru',
          source:
            '[{"resolution":720,"path":"https://tonplace.ams3.cdn.digitaloceanspaces.com/videos/848/4a4edc78-7fa3-4273-7e90-7ff7c545be72.mp4"}]',
          width: 720,
          height: 1280,
        },
      },
      {
        id: 171459,
        name: 'Caroline Queen',
        photo: {
          default:
            'https://tonplace.ams3.cdn.digitaloceanspaces.com/photos/354/6d3deff0-6ba0-45bd-4108-4363db4350d7.jpg',
        },
        inst: {
          subs: 402000,
          link: 'https://www.instagram.com/caroline.queen.official/',
        },
        welcomeVideo: {
          lang: 'en',
          videoId: 276428,
          source:
            '[{"resolution":720,"path":"https://tonplace.ams3.cdn.digitaloceanspaces.com/videos/411/ca6e879c-f924-47f6-521b-dda623c812a2.mp4"}]',
          width: 720,
          height: 1280,
        },
      },
      {
        id: 195886,
        name: 'Ice Baby',
        photo: {
          default:
            'https://tonplace.ams3.cdn.digitaloceanspaces.com/photos/277/4a680de8-f17e-4c79-63d3-b99ffde8da5d.jpg',
        },
        inst: {
          link: 'https://www.instagram.com/missaiss_/',
          subs: 181000,
        },
        welcomeVideo: {
          lang: 'en',
          videoId: 274572,
          source:
            '[{"resolution":720,"path":"https://tonplace.ams3.cdn.digitaloceanspaces.com/videos/896/ba93f413-fe87-4299-6755-d5f3c68b926d.mp4"}]',
          width: 980,
          height: 1280,
        },
      },
      {
        id: 286797,
        name: 'Tiny Bunny',
        photo: {
          default:
            'https://tonplace.ams3.cdn.digitaloceanspaces.com/photos/250/c9a768d7-330c-4892-7a5f-c26f756ccf2a.jpg',
        },
        welcomeVideo: {
          lang: 'en',
          videoId: 274093,
          source:
            '[{"resolution":720,"path":"https://tonplace.ams3.cdn.digitaloceanspaces.com/videos/405/c3573efe-e13d-474a-6a4d-f7578cd3e197.mp4"}]',
          width: 720,
          height: 1280,
        },
        inst: {
          subs: 29400,
          link: 'https://www.instagram.com/tinybunny69/',
        },
      },
      {
        id: 284817,
        name: 'Kaeru Kukki',
        photo: {
          default:
            'https://tonplace.ams3.cdn.digitaloceanspaces.com/photos/894/bec5b082-fa29-480f-7c16-a92d7267d9dd.jpg',
        },
        welcomeVideo: {
          lang: 'en',
          videoId: 272219,
          source:
            '[{"resolution":720,"path":"https://tonplace.ams3.cdn.digitaloceanspaces.com/videos/987/da8d4467-54a8-4bbb-5966-2438ab3a47b9.mp4"}]',
          width: 1440,
          height: 2560,
        },
        inst: {
          subs: 23700,
          link: 'https://www.instagram.com/kaeru_kukki/',
        },
      },
      {
        id: 254095,
        name: 'Victoria Rainbow',
        photo: {
          default:
            'https://tonplace.ams3.cdn.digitaloceanspaces.com/photos/32/aeb3b7de-62aa-4bf0-50b6-0ec59414f1e3.jpg',
        },
        inst: {
          link: 'https://Instagram.com/reyven_virgo',
          subs: 4000,
        },
        welcomeVideo: {
          lang: 'en',
          source:
            '[{"resolution":720,"path":"https://tonplace.ams3.cdn.digitaloceanspaces.com/videos/282/b32d37ad-0ad1-417f-653d-d3ad82b144b0.mp4"}]',
          thumbnail:
            'data:image/png;base64,/9j/2wCEAAgGBgcGBQgHBwcJCQgKDBQNDAsLDBkSEw8UHRofHh0aHBwgJC4nICIsIxwcKDcpLDAxNDQ0Hyc5PTgyPC4zNDIBCQkJDAsMGA0NGDIhHCEyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMv/AABEIABAACQMBIgACEQEDEQH/xAGiAAABBQEBAQEBAQAAAAAAAAAAAQIDBAUGBwgJCgsQAAIBAwMCBAMFBQQEAAABfQECAwAEEQUSITFBBhNRYQcicRQygZGhCCNCscEVUtHwJDNicoIJChYXGBkaJSYnKCkqNDU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6g4SFhoeIiYqSk5SVlpeYmZqio6Slpqeoqaqys7S1tre4ubrCw8TFxsfIycrS09TV1tfY2drh4uPk5ebn6Onq8fLz9PX29/j5+gEAAwEBAQEBAQEBAQAAAAAAAAECAwQFBgcICQoLEQACAQIEBAMEBwUEBAABAncAAQIDEQQFITEGEkFRB2FxEyIygQgUQpGhscEJIzNS8BVictEKFiQ04SXxFxgZGiYnKCkqNTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqCg4SFhoeIiYqSk5SVlpeYmZqio6Slpqeoqaqys7S1tre4ubrCw8TFxsfIycrS09TV1tfY2dri4+Tl5ufo6ery8/T19vf4+fr/2gAMAwEAAhEDEQA/AOis4lS5urdJpYxN8zqjgDjA6Y9sH2rP/wCEQi/55x/lVDwPrFjDopNwUhWBYzPI0xyxfGSQc55YfU5rvvsi/wDPSH/vn/69ZSbpSaaOlRVWCs9j/9k=',
          width: 720,
          height: 1280,
        },
      },
      {
        id: 285677,
        name: 'Darya Berkut',
        photo: {
          default:
            'https://tonplace.ams3.cdn.digitaloceanspaces.com/photos/155/ee4d4152-ef22-48b3-516d-eaf2b4c11002.jpg',
        },
        welcomeVideo: {
          lang: 'en',
          source:
            '[{"resolution":720,"path":"https://tonplace.ams3.cdn.digitaloceanspaces.com/videos/663/cf42dfd2-0512-4875-7413-91f546c438c7.mp4"}]',
          width: 720,
          height: 1280,
        },
      },
      {
        id: 280952,
        name: 'MaryanaRo',
        photo: require('./assets/MaryanaRo.png'),
        inst: {
          subs: 7700000,
          link: 'https://instagram.com/maryanaro?igshid=YmMyMTA2M2Y=',
        },
      },
      {
        id: 193379,
        name: 'Alena Omovych',
        photo: require('./assets/Alena_Omovych.png'),
        inst: {
          subs: 2200000,
          link: 'https://www.instagram.com/alena_omovych',
        },
      },
      {
        id: 225101,
        name: 'Ekaterina Zueva',
        photo: require('./assets/Ekaterina_Zueva.png'),
        inst: {
          subs: 2800000,
          link: 'https://instagram.com/zuueva?igshid=YmMyMTA2M2Y=',
        },
      },
      {
        id: 190251,
        name: 'ilona korinets',
        photo: require('./assets/ilona_korinets.png'),
        inst: {
          subs: 751000,
          link: 'https://www.instagram.com/ilona_korinets',
        },
      },
      {
        id: 166654,
        name: 'Lera Buns',
        photo: require('./assets/Lera_Buns.png'),
        inst: {
          subs: 554000,
          link: 'https://www.instagram.com/lerabuns',
        },
      },
      {
        id: 196184,
        name: 'Olya Abramovich',
        photo: require('./assets/Olya_Abramovich.png'),
        inst: {
          subs: 1800000,
          link: 'https://www.instagram.com/oabramovich',
        },
      },
      {
        id: 24337,
        name: 'Yulchik bb',
        photo: require('./assets/Yulchik_bb.png'),
        inst: {
          subs: 552000,
          link: 'https://www.instagram.com/yulchikbb',
        },
      },
      {
        id: 178898,
        name: 'Kateryna Milevskaya',
        photo: require('./assets/Kateryna_Milevskaya.png'),
        inst: {
          subs: 564000,
          link: 'https://www.instagram.com/milevskate',
        },
      },
      {
        id: 189827,
        name: 'Kristina Musatova',
        photo: require('./assets/Kristina_Musatova.png'),
        inst: {
          subs: 1100000,
          link: 'https://instagram.com/musatovaak?igshid=YmMyMTA2M2Y=',
        },
      },
      {
        id: 168848,
        name: 'Anastasia Lisina',
        photo: require('./assets/Anastasia_Lisina.png'),
        inst: {
          subs: 231000,
          link: 'https://www.instagram.com/nastyal/',
        },
      },
      {
        id: 166652,
        name: 'Natalia Rachkovich',
        photo: require('./assets/Natalia_Rachkovich.png'),
        inst: {
          subs: 546000,
          link: 'https://www.instagram.com/natalia_rachkovich',
        },
      },
    ];
  }, [currentLang]);

  const viewerItems = models.reduce(
    (viewerItems: ViewerItem[], { welcomeVideo }, ind) => {
      if (welcomeVideo) {
        const { source, height, width, lang } = welcomeVideo;
        if (lang === 'en' || currentLang.key === lang) {
          viewerItems.push({
            id: -ind,
            source: JSON.parse(source)[0]?.path,
            width,
            height,
          });
        }
      }

      return viewerItems;
    },
    [],
  );

  useEffect(() => {
    setSubscriptionContentPriority(ContentPriorityType.ADULT);
    statReachGoal('adult_paywall');
    statReachGoal('new_paywall');

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  const signInHandle = useCallback(() => {
    dispatch(profileActions.setAuthPopoverState(AuthPopoverState.LOGIN));
  }, []);

  const handleItemClick = (item: typeof models[number], ind) => {
    const { welcomeVideo, id } = item;

    if (
      welcomeVideo &&
      (welcomeVideo.lang == 'en' || welcomeVideo.lang === currentLang.key)
    ) {
      setCurrentViewerItem(ind);
    } else {
      router.navigate(PROFILE, { id });
    }
  };

  const handleCloseViewer = () => {
    setCurrentViewerItem(null);
  };

  const handleKeyDown = (e: KeyboardEvent) => {
    if (e.key === 'Escape') {
      handleCloseViewer();
    }
  };

  const modelsSorted = useMemo(() => {
    return models.sort((a, b) => {
      let w1 = a.welcomeVideo;
      let w2 = b.welcomeVideo;

      if (w1 && w1.lang !== 'en' && w1.lang !== currentLang.key) {
        w1 = undefined;
      }

      if (w2 && w2.lang !== 'en' && w2.lang !== currentLang.key) {
        w2 = undefined;
      }

      if (w1 && !w2) {
        return -1;
      } else if (w2 && !w1) {
        return 1;
      } else if (w1 && w2) {
        const l1 = w1.lang === currentLang.key;
        const l2 = w2.lang === currentLang.key;

        return l1 === l2 ? 0 : l1 ? -1 : 1;
      } else {
        return 0;
      }
    });
  }, [models, currentLang]);

  function renderContent() {
    return (
      <div>
        <div className="AdultPaywall__cont">
          <Slider scrollIndent={120}>
            {modelsSorted.map((item, i) => (
              <div key={i} className="AdultPaywall__model">
                <div
                  onClick={() => handleItemClick(item, i)}
                  className="AdultPaywall__model_cont"
                  style={{ backgroundImage: `url(${item.photo.default})` }}
                >
                  {item.welcomeVideo &&
                    (item.welcomeVideo.lang === 'en' ||
                      item.welcomeVideo.lang === currentLang.key) && (
                      <div className="AdultPaywall__model__play_btn">
                        <IcPlay28 />
                      </div>
                    )}
                  <div className="AdultPaywall__model__name">{item.name}</div>
                </div>
                {item.inst && (
                  <a
                    className="AdultPaywall__model__inst_label"
                    href={item.inst.link}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {formatBigNumber(item.inst.subs)}
                  </a>
                )}
              </div>
            ))}
          </Slider>
          <div className="AdultPaywall_info">
            <div className="AdultPaywall_title">
              {t('adult_paywall_info_title')}
              {isBlackFriday() && (
                <div className="adult_paywall_info_blackFriday">
                  {t('profile_subscription_common_discount_black_friday')}
                </div>
              )}
              <br />
              {t('adult_paywall_info_title_sub')}
            </div>
            <div className="AdultPaywall_caption">{t('adult_paywall_info_caption')}</div>
          </div>
        </div>
        <div className="AuthorPaywall__list">
          <div className="AuthorPaywall__item">
            <div className="AuthorPaywall__item__icon _cyan">
              <IcCheck28 />
            </div>
            <div>
              <div className="AuthorPaywall__item__title">
                {t('adult_paywall_new_list_item_1_title')}
              </div>
              <div className="AuthorPaywall__item__description">
                {t('adult_paywall_new_list_item_1_caption')}
              </div>
            </div>
          </div>
          <div className="AuthorPaywall__item">
            <div className="AuthorPaywall__item__icon _red">
              <IcHot28 />
            </div>
            <div>
              <div className="AuthorPaywall__item__title">
                {t('adult_paywall_new_list_item_2_title')}
              </div>
              <div className="AuthorPaywall__item__description">
                {t('adult_paywall_new_list_item_2_caption')}
              </div>
            </div>
          </div>
          <div className="AuthorPaywall__item">
            <div className="AuthorPaywall__item__icon _pink">
              <IcMessage28 />
            </div>
            <div>
              <div className="AuthorPaywall__item__title">
                {t('adult_paywall_new_list_item_3_title')}
              </div>
              <div className="AuthorPaywall__item__description">
                {t('adult_paywall_new_list_item_3_caption')}
              </div>
            </div>
          </div>
          <div className="AuthorPaywall__item">
            <div className="AuthorPaywall__item__icon _green">
              <IcPhone28 />
            </div>
            <div>
              <div className="AuthorPaywall__item__title">
                {t('adult_paywall_new_list_item_4_title')}
              </div>
              <div className="AuthorPaywall__item__description">
                {t('adult_paywall_new_list_item_4_caption')}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  function renderButton() {
    if (!isLogged) {
      return (
        <Button onClick={handleSubscription} flare className="AdultPaywall__button">
          {t('buy_subscription_login_button')}
        </Button>
      );
    }

    return (
      <Button onClick={handleSubscription} flare>
        {subscriptionRubPrice ? (
          t('adult_auth_btn', {
            price: formatCurrency(subscriptionRubPrice || 1, CurrencyEnum.EUR),
          })
        ) : (
          <Loader />
        )}
      </Button>
    );
  }

  return (
    <>
      <Header showCloseButton>{t('adult_paywall_title')}</Header>
      <ScrollView footer={renderButton()}>{renderContent()}</ScrollView>
      <AuthPopoverSimple />
      {currentViewerItem !== null && (
        <Viewer
          items={viewerItems}
          active={currentViewerItem}
          onChange={setCurrentViewerItem}
          onClose={handleCloseViewer}
          mobile={!isDesktop}
        />
      )}
    </>
  );
};
